import Scale from "./Scale"
import Note from "./Note"
import DrumKit from "./DrumKitKat"




export default {
    Scale, Note, DrumKit
}